import Check from '../src/Check/index';
export default Check;
